import { t, Trans } from '@lingui/macro';
import { FormControlLabel, FormLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import PropTypes from 'prop-types';
import { NgpTagsField } from '../../../form/NgpTagsField';
import NgpRow from '../../../form/NgpRow';
import { useStyles } from './sections/TestPathAnalysisSection';
import { AGENT_TAGS_FIELD_NAME, TAG_AND, TAG_OR } from '../ServiceTestsConstants';

const useLocalStyles = makeStyles((theme) => ({
    tagOpWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(2),
        '& .MuiFormLabel-root': {
            height: '16px',
        },
        '& .MuiFormControlLabel-root': {
            marginTop: 0,
        },
    },
}));

/**
 * ServiceTestAgentsTagSection
 *
 * Renders the "tagged" mode UI for ServiceTestAgentSelector:
 * - Tag operation radio (Any / All)
 * - Agent tags autocomplete field
 *
 * @param {string} tagOp - 'OR' | 'AND'
 * @param {Function} handleTagOpChange - called with new tagOp value
 * @param {Array} agentTags - pre-fetched agent tag options from parent
 */
export function ServiceTestAgentsTagSection({ tagOp, handleTagOpChange, agentTags }) {
    const classes = useStyles();
    const localClasses = useLocalStyles();

    return (
        <>
            <NgpRow className={classes.row}>
                <div className={localClasses.tagOpWrapper}>
                    <FormLabel component="legend">
                        <Trans>Tag:</Trans>
                    </FormLabel>
                    <RadioGroup row value={tagOp} onChange={(e) => handleTagOpChange(e.target.value)}>
                        <FormControlLabel value={TAG_OR} label={t`Any`} control={<Radio />} />
                        <FormControlLabel value={TAG_AND} label={t`All`} control={<Radio />} />
                    </RadioGroup>
                </div>
            </NgpRow>
            <NgpTagsField
                fieldName={AGENT_TAGS_FIELD_NAME}
                label={t`Agent Tags`}
                options={agentTags}
                allowNewTags={false}
            />
        </>
    );
}

ServiceTestAgentsTagSection.propTypes = {
    tagOp: PropTypes.oneOf([TAG_OR, TAG_AND]).isRequired,
    handleTagOpChange: PropTypes.func.isRequired,
    agentTags: PropTypes.array.isRequired,
};

export default ServiceTestAgentsTagSection;
